import { loadBrand } from '@/core/store/api/loadBrand'
import { isCanadianBrand } from '@/core/store/isCanadianBrand'
import { useCoreStore } from '@/core/store/useCoreStore'
import { logError } from '@/logger'
import type { HermesGuardFn } from '@/router/guards/types'

const PRINT_SHOP_ROUTE_PREFIX = 'brand.marketing.print-shop'

const getFirstString = (value: unknown): string | undefined => {
  if (Array.isArray(value)) {
    return value.find(
      (entry): entry is string => typeof entry === 'string' && entry.length > 0
    )
  }

  return typeof value === 'string' && value.length > 0 ? value : undefined
}

const redirectToBrandHome = (brandId: string) => ({
  name: 'brand.home',
  params: { brandId },
})

export const checkCanadianPrintShopBlocked: HermesGuardFn = async (to) => {
  if (
    typeof to.name !== 'string' ||
    !to.name.startsWith(PRINT_SHOP_ROUTE_PREFIX)
  ) {
    return undefined
  }

  const brandId = getFirstString(to.params.brandId)
  if (!brandId) {
    return undefined
  }

  const coreStore = useCoreStore()
  if (coreStore.activeBrand?.id !== brandId) {
    try {
      await loadBrand(brandId)
    } catch (error) {
      logError(error, {
        brandId,
        source: 'canadian-print-shop-blocked',
      })
      return redirectToBrandHome(brandId)
    }
  }

  if (coreStore.activeBrand?.id !== brandId) {
    return redirectToBrandHome(brandId)
  }

  if (!isCanadianBrand()) {
    return undefined
  }

  return redirectToBrandHome(brandId)
}
